<svelte:options />

<script>
    import { fieldStates } from '@repo/config/Global';


    import { createEventDispatcher } from 'svelte';
    /**
     * @typedef {Object} Props
     * @property {any} name
     * @property {boolean} [required]
     * @property {string} [value]
     * @property {any} [associatedID]
     * @property {number} [tabindex]
     * @property {any} [state]
     */
    let {
        name,
        required = false,
        value = $bindable(''),
        associatedID = null,
        tabindex = 0,
        state = fieldStates.NEUTRAL
    } = $props();

    const dispatch = createEventDispatcher();

    function handleChange(e) {
        value = e.target.value;
        dispatch('change', {
            originalEvent: e,
            name,
            value,
            required,
            associatedID,
        });
    }

    export {
        name,
        required,
        value,
        associatedID,
        tabindex,
        state,
    };
</script>

<div class="date-input">
    <input
        {tabindex}
        class="input date {state}"
        onchange={handleChange}
        onkeyup={(e) => {
            dispatch('keyup', e);
        }}
        type="date"
        {name}
        {required}
        {value}
    />
</div>

<style>
    .date-input {
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-grow: 10;
        width: 100%;
        max-width: 24rem;
    }

    .date-input:not(:last-of-type) {
        margin-right: 1rem;
    }

    .input {
        padding: 0.75rem;
        background-color: rgba(0, 0, 0, 0.6);
        color: #eee;
        border-radius: 0.35rem;
        border: solid 1px rgba(0, 0, 0, 0.1);
        outline-width: 1px;
        width: 100%;
    }

    .field_state_error {
        outline-style: solid;
        outline-color: crimson;
    }

    .input:valid,
    .field_state_waiting {
        outline-style: solid;
        outline-color: rgb(74, 198, 255);
    }

    .field_state_neutral {
        outline-style: solid;
        outline-color: rgb(199, 199, 199);
    }

    .field_state_success {
        outline-style: solid;
        outline-color: rgb(74, 255, 83);
    }

    .input:focus {
        outline-width: 3px;
    }
</style>
